module.exports = __webpack_public_path__ + "static/media/api-key-icon.b6835271.png";